var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 25.5",
    style: {
      enableBackground: "new 0 0 39.7 25.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7,12.1l-7.8,7.8c-1.6,1.6-3.2,3.2-4.8,4.8c-0.6,0.8-1.7,0.9-2.5,0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-1.2-1.2-2.4-2.4-3.6-3.6 c-0.8-0.6-0.9-1.7-0.3-2.5c0,0,0.1-0.1,0.2-0.2L18.4,0.7c0.5-0.8,1.6-1,2.3-0.5c0.2,0.1,0.3,0.3,0.5,0.5C27.1,6.6,33,12.5,38.9,18.4 c0.8,0.6,0.9,1.7,0.3,2.4c-0.1,0.1-0.2,0.2-0.3,0.3c-1.2,1.3-2.3,2.4-3.5,3.6c-1.2,1.2-2,1-3,0c-4-3.9-7.9-7.9-11.9-11.9 C20.3,12.6,20,12.4,19.7,12.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.6ca15c56cbdc277e51ba846007f231ea.svg";
export { ForwardRef as ReactComponent };